// extracted by mini-css-extract-plugin
export default {"rating":"zF-z","numberOfStars":"AF-z","count":"BF-z","barGraphSpacing":"CF-z","barGraph":"DF-z"};